var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.htmlContent === null || _vm.htmlContent.trim() === '')?_c('div',{staticClass:"html-content break-word"}):_c('div',{staticClass:"html-content break-word",domProps:{"innerHTML":_vm._s(_vm.htmlContent.replace(/<p>/g, `<p style='margin-bottom: 0'>`))}})
}
var staticRenderFns = []

export { render, staticRenderFns }